import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useMemo, useRef } from 'react';
import { useTheme } from 'styled-components';
import Icons from '../../Elements/Icons';
import Label from '../Label';
import { stopPropagation } from './helpers';
import { IndeterminateIcon } from './IndeterminateIcon';
import { CheckboxContainer, CheckboxWrapper, HiddenCheckbox, StyledCheckbox } from './styled';
export const Checkbox = memo(function Checkbox({ className, checked, disabled, indeterminate, label, tooltip, required, onChange, dataTestId, ...props }) {
    const { colors } = useTheme();
    const inputRef = useRef(null);
    const iconColor = useMemo(() => (disabled && (checked || indeterminate) ? colors.grey01_2 : colors.grey00_2), [disabled, checked, indeterminate, colors.grey01_2, colors.grey00_2]);
    useEffect(() => {
        if (!inputRef.current) {
            return;
        }
        inputRef.current.indeterminate = indeterminate ?? false;
    }, [indeterminate]);
    return (_jsxs(CheckboxContainer, { className: className, disabled: disabled, "data-test-checked": checked || false, onClick: stopPropagation, children: [_jsxs(CheckboxWrapper, { children: [_jsx(HiddenCheckbox, { ref: inputRef, type: 'checkbox', checked: checked, disabled: disabled, onChange: onChange, ...props }), _jsxs(StyledCheckbox, { checked: checked || false, disabled: disabled, "$indeterminate": indeterminate, "data-testid": dataTestId, children: [checked && !indeterminate && _jsx(Icons.Checkmark, { size: 17, color: iconColor }), indeterminate && !checked && _jsx(IndeterminateIcon, { color: iconColor })] })] }), label ? (_jsx(Label, { as: 'span', "data-testid": dataTestId, tooltip: tooltip, required: required, children: label })) : null] }));
});
export { HiddenCheckbox, StyledCheckbox };
